export default __webpack_public_path__ + "images/side-bar-icon-blue.svg";